export enum HttpStatusCodes {
    OK = 200,
    NOT_MODIFIED = 304,
    UNAUTHORISED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    INTERNAL_ERROR = 500,
    SERVER_UNAVAILABLE = 503
}
